import type { FetchTruckTypesQuery } from '@/features/truck-types/api'
import type { TruckTypesSearch } from '@/routes/_protected/$tenantKey/settings/_system-master-settings/truck-types/-models'

export function buildFetchTruckTypesQuery(
  tenantKey: string,
  deps: TruckTypesSearch
): FetchTruckTypesQuery {
  return {
    tenantKey,
    query: {
      ...deps,
      enable: deps.enable ?? undefined
    }
  }
}
